module.exports = __webpack_public_path__ + "img/daglig-kontroll-ikon.5214783f.png";